import messageBox from './index.vue';

export default {
  install(Vue, options) {
    Vue.prototype.$messageBox = function(opts) {
      // 继承messageBox组件
      const MessageConstructor = Vue.extend(messageBox);
      // 创建一个新元素
      const messageWrap = document.createElement('div');
      messageWrap.className = 'message-box-wrap';
      // 实例化messageBox组件，并将组件挂在到新创建的message-box-wrap元素上
      const messageInstace = new MessageConstructor({
        el: messageWrap
      });
      // 或者使用 messageInstace.$mount(messageWrap)挂载
      document.body.appendChild(messageInstace.$el);
      // 显示组件内容
      if (opts) {
        messageInstace.icon = opts.icon;
        messageInstace.severity = opts.severity;
        messageInstace.confirmTitle = opts.confirmTitle;
        messageInstace.title = opts.title;
        messageInstace.subTitle = opts.subTitle;
        messageInstace.list = opts.list;
        messageInstace.confirmText = opts.confirmText;
        messageInstace.btnText = opts.btnText;
        messageInstace.callBack = opts.callBack;
        messageInstace.onClose = opts.onClose;
        messageInstace.showCancel = opts.showCancel;
        messageInstace.showClose = opts.showClose;
        messageInstace.autoConfirm = opts.autoConfirm;
        messageInstace.cancelCallBack = opts.cancelCallBack;
      }
      messageInstace.centerDialogVisible = true;
      if (messageInstace.autoConfirm) {
        setTimeout(() => {
          console.log(messageInstace);
          messageInstace.confirm();
        }, 1500);
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/messageBox/index.js